(function () {
    if (customElements.get("plug-variant-picker")) return;

    const departmentPrefixes = ["Men's", "Women's", "Kid's"];

    class PlugVariantPicker extends HTMLElement {
        constructor() {
            super();

            this.department = this.dataset.department;
            this.sectionId = this.dataset.section;
            this.currentVariant = undefined;
            this.currentProduct = JSON.parse(document.getElementById("PlugProductJson").innerHTML).product;
            this.variantData = undefined;  // Data for all variants. Equal to product.variants | json.
            this.options = [];
            this.addEventListener("change", this.onVariantChange);
        }

        onVariantChange(e) {
            console.log("variant change listener", {e});
            const input = e.target;
            const isInitialDepartmentChange = (input.dataset.isInitial === "true");
            input.dataset.isInitial = "false";
            const label = this.querySelector(`label[for="${input.id}"]`);
            const fieldset = input.closest("fieldset");
            const isCustomOption = fieldset.classList.contains("plug-custom-variant-option");
            const legendValueLabel = fieldset.querySelector("legend span");
            legendValueLabel.textContent = (
                input.name.toLowerCase === "style"
                ? legendValueLabel.textContent = input.dataset.displayName
                : input.value
            );

            if (isCustomOption) {
                const eventData = {
                    data: {
                        radioButtonLabel: label,
                        departmentIndex: this.getActiveDepartmentIndex(),
                        style: this.getActiveStyle(),
                        isInitialDepartmentChange: isInitialDepartmentChange
                    }
                };
                if (input.name === "department") {
                    publish(PUB_SUB_EVENTS.productDepartmentChange, eventData);
                } else if (input.name === "style") {
                    publish(PUB_SUB_EVENTS.productStyleChange, eventData);
                } else {
                    console.error(`Unrecognized custom variant option input name: ${input.name}.`);
                }
            } else {
                this.updateActiveVariant();
            }
        }

        updateActiveVariant(activeProduct, activeVariant) {
            if (activeProduct) {
                this.currentProduct = activeProduct;
            }
            this.updateOptions(activeProduct, activeVariant);

            this.updateMasterId();
            this.toggleAddButton(true, "", false);
            this.removeErrorMessage();
            this.updateVariantStatuses();

            if (!this.currentVariant) {
                this.toggleAddButton(true, "", true);
                this.setUnavailable();
            } else {
                this.updateMedia();
                this.updateURL();
                this.updateVariantInput();
                this.renderProductInfo(activeProduct, activeVariant).then(() => {
                    this.updateShareUrl();
                }).catch(err => {
                    console.error(err);
                });
            }
        }

        // Plug Method
        getActiveDepartmentIndex() {
            const departmentInputs = Array.from(this.querySelectorAll("[name=\"department\"]"));
            let k = 0;
            while (k < departmentInputs.length) {
                if (departmentInputs[k].checked) {
                    break;
                }
                k += 1;
            }
            console.log({activeDepartmentIndex: k});
            return k;
        }

        // Plug Method
        getActiveStyle() {
            const styleInputs = Array.from(this.querySelectorAll("[name=\"style\"]"));
            const checkedInput = styleInputs.find(styleInput => styleInput.checked);
            return checkedInput.value;
        }

        updateOptions(activeProduct, activeVariant) {
            // Update standard variant options (size and color).
            const fieldsets = Array.from(this.getElementsByClassName("plug-standard-variant-option"));

            // Make sure the correct style and color values are selected.
            if (activeProduct && activeVariant) {
                const lowercaseOptionNames = activeProduct.options.map(option => option.toLowerCase());
                const colorOptionIndex = lowercaseOptionNames.indexOf("color");
                const sizeOptionIndex = lowercaseOptionNames.indexOf("size");
                const activeColor = activeVariant.options[colorOptionIndex];
                const activeSize = activeVariant.options[sizeOptionIndex];
                fieldsets.forEach((fieldset, index) => {
                    const name = fieldset.dataset.optionName;
                    const inputs = Array.from(fieldset.getElementsByTagName("input"));
                    const valueLabel = fieldset.querySelector("legend span");
                    if (name === "Color") {
                        valueLabel.textContent = activeColor;
                        inputs.forEach(input => {
                            input.checked = (input.value === activeColor);
                        });
                    } else if (name === "Size") {
                        valueLabel.textContent = activeSize;
                        inputs.forEach(input => {
                            input.checked = (input.value === activeSize);
                        });
                    }
                });
            }

            this.options = fieldsets.map((fieldset) => {
                return Array.from(fieldset.getElementsByTagName("input")).find((radio) => radio.checked).value;
            });
        }

        updateMasterId() {
            if (this.currentProduct.variants.length === 1) {
                this.currentVariant = this.getVariantData()[0];
            } else {
                this.currentVariant = this.getVariantData().find((variant) => {
                    return !variant.options
                        .map((option, index) => {
                            return this.options[index] === option;
                        })
                        .includes(false);
                });
            }
        }

        updateMedia() {
            if (!this.currentVariant) return;
            if (!this.currentVariant.featured_media) return;

            const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
            const prevActiveLi = mediaGalleries[0].querySelector("li.is-active");
            if (prevActiveLi && prevActiveLi.dataset.mediaId === `${this.dataset.section}-${this.currentVariant.featured_media.id}`) {
                return;
            }
            mediaGalleries.forEach((mediaGallery) =>
                mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true)
            );

            const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
            if (!modalContent) return;
            const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
            modalContent.prepend(newMediaModal);
        }

        updateURL() {
            if (!this.currentVariant || this.dataset.updateUrl === "false") return;
            window.history.replaceState({}, "", `${this.dataset.url}?variant=${this.currentVariant.id}`);
        }

        updateShareUrl() {
            const shareButton = document.getElementById(`Share-${this.dataset.section}`);
            if (!shareButton || !shareButton.updateUrl) return;
            shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
        }

        updateVariantInput() {
            const productForms = document.querySelectorAll(
                `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
            );
            productForms.forEach((productForm) => {
                const input = productForm.querySelector("input[name=\"id\"]");
                input.value = this.currentVariant.id;
                input.dispatchEvent(new Event("change", { bubbles: true }));
            });
        }

        updateVariantStatuses() {
            const selectedOptionOneVariants = this.variantData.filter(variant => {
                const checkedInput = this.querySelector(".plug-standard-variant-option :checked");
                return (
                    checkedInput
                    && variant.option1 === checkedInput.value
                );
            });
            const inputWrappers = [...this.querySelectorAll(".plug-standard-variant-option")];
            inputWrappers.forEach((option, index) => {
                if (index === 0) return;
                const optionInputs = [...option.querySelectorAll("input[type=\"radio\"], option")];
                const previousOptionSelected = inputWrappers[index - 1].querySelector(":checked").value;
                const availableOptionInputsValue = selectedOptionOneVariants
                    .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
                    .map((variantOption) => variantOption[`option${index + 1}`]);
                this.setInputAvailability(optionInputs, availableOptionInputsValue);
            });
        }

        setInputAvailability(listOfOptions, listOfAvailableOptions) {
            listOfOptions.forEach((input) => {
                if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
                    input.classList.remove("disabled");
                } else {
                    input.classList.add("disabled");
                }
            });
        }

        removeErrorMessage() {
            const section = this.closest("section");
            if (!section) return;

            const productForm = section.querySelector("product-form");
            if (productForm) productForm.handleErrorMessage();
        }

        async renderProductInfo(product, variant) {
            const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

            product = product || this.currentProduct;
            variant = variant || this.currentVariant;

            const priceContainer = document.querySelector(".plug-product-price-container");
            priceContainer.classList.remove("visibility-hidden");
            const oldPrice = priceContainer.querySelector(".price");
            const newPrice = PLUG.utils.stringToDocFrag(
                PLUG.utils.buildPriceSnippet(product, variant)
            );
            oldPrice.parentElement.insertBefore(newPrice, oldPrice);
            oldPrice.parentElement.removeChild(oldPrice);

            const skuSpan = document.querySelector("[data-plug-sku]");
            if (skuSpan) {
                skuSpan.textContent = this.currentVariant.sku;
            }

            const description = document.querySelector(".product__description");
            description.innerHTML = product.description;

            this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);

            const docFrag = document.createDocumentFragment();
            const section = document.querySelector(".main-product-section");
            docFrag.appendChild(section.cloneNode(true));

            publish(PUB_SUB_EVENTS.variantChange, {
                data: {
                    sectionId,
                    html: docFrag,
                    variant: JSON.parse(JSON.stringify(this.currentVariant)),
                },
            });
        }

        toggleAddButton(disable=true, text, modifyClass=true) {
            const productForm = document.getElementById(`product-form-${this.dataset.section}`);
            if (!productForm) return;
            const addButton = productForm.querySelector("[name=\"add\"]");
            const addButtonText = productForm.querySelector("[name=\"add\"] > span");
            if (!addButton) return;

            if (disable) {
                addButton.setAttribute("disabled", "disabled");
                if (text) addButtonText.textContent = text;
            } else {
                addButton.removeAttribute("disabled");
                addButtonText.textContent = window.variantStrings.addToCart;
            }

            if (!modifyClass) return;
        }

        setUnavailable() {
            const button = document.getElementById(`product-form-${this.dataset.section}`);
            const addButton = button.querySelector("[name=\"add\"]");
            const addButtonText = button.querySelector("[name=\"add\"] > span");
            const price = document.getElementById(`price-${this.dataset.section}`);
            const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
            const sku = document.getElementById(`Sku-${this.dataset.section}`);

            if (!addButton) return;
            addButtonText.textContent = window.variantStrings.unavailable;
            if (price) price.classList.add("visibility-hidden");
            if (inventory) inventory.classList.add("visibility-hidden");
            if (sku) sku.classList.add("visibility-hidden");
        }

        getVariantData() {
            this.variantData = this.variantData || JSON.parse(this.querySelector("[type=\"application/json\"]").textContent);
            return this.variantData;
        }

        /**
         * @param {HTMLElement} ele - The <plug-variant-picker> element.
         * @param {string[]} styles
         * @param {number} activeStyleIndex
         * @param {string} departmentTitle
         */
        static setStyles(ele, styles, activeStyleIndex, departmentTitle) {
            const styleFieldset = ele.querySelector(".plug-custom-variant-option[data-option-name=\"Style\"]");
            const inputs = Array.from(styleFieldset.getElementsByTagName("input"));
            const labels = Array.from(styleFieldset.getElementsByTagName("label"));
            const formId = inputs[0].getAttribute("form");
            const styleButtonsDocFrag = PlugVariantPicker.buildStyleRadioButtons(styles, activeStyleIndex, formId, departmentTitle);

            inputs.forEach(input => input.parentElement.removeChild(input));
            labels.forEach(label => label.parentElement.removeChild(label));
            if (styles[activeStyleIndex]) {
                styleFieldset.querySelector("legend span").textContent = (
                    departmentTitle === "Men's"
                        ? PlugVariantPicker.removeDepPrefix(
                            styles[activeStyleIndex].split(" ").filter(word => word.toLowerCase() !== "unisex").join(" ")
                        )
                        : PlugVariantPicker.removeDepPrefix(styles[activeStyleIndex])
                );
            } else {
                console.log("no active style", {styles: JSON.parse(JSON.stringify(styles)), activeStyleIndex});
            }

            styleFieldset.appendChild(styleButtonsDocFrag);
        }

        static setDepartment(departmentTitle) {
            console.log("SET DEPARTMENT")
            console.log(departmentTitle)
            const input = document.querySelector(`[name="department"][value="${departmentTitle}"]`);
            if (input) {
                input.dataset.isInitial = "true";
                input.click();
            } else {
                console.error(`Can't find department info with value ${departmentTitle}`);
            }
        }

        /**
         * @param {string[]} styles
         * @param {number} activeStyleIndex
         * @param {string} formId
         * @param {string} departmentTitle
         * @return {DocumentFragment}
         */
        static buildStyleRadioButtons(styles, activeStyleIndex, formId, departmentTitle) {
            const radioButtonStrings = [];

            styles.forEach((value, index) => {
                const styleDisplayName = PLUG.utils.getStyleDisplayName(value, departmentTitle);
                radioButtonStrings.push(
                    `<input
                        type="radio"
                        id="PlugDepartmentStyle-${index}"
                        name="style"
                        value="${value}"
                        data-display-name="${styleDisplayName}"
                        form="${formId}"
                        ${(index === activeStyleIndex) ? "checked" : ""}
                    >
                    <label for="PlugDepartmentStyle-${index}">
                        ${styleDisplayName}
                        <span class="visually-hidden">${window.plugProductStrings.variantSoldOutOrUnavailable}</span>
                    </label>`
                );
            });
            return PLUG.utils.stringToDocFrag(radioButtonStrings.join(""));
        }

        /**
        * @param {string} style
        */
        static removeDepPrefix(style) {
            return style.split(" ").filter(word => {
                word = word.toLowerCase();
                return (
                    word !== "men's"
                    && word !== "women's"
                    && word !== "kid's"
                );
            }).join(" ");
        }
    }

    customElements.define("plug-variant-picker", PlugVariantPicker);

    PLUG.elementClasses = PLUG.customElementClasses || {};
    PLUG.elementClasses.PlugVariantPicker = PlugVariantPicker;
})();
